import { H2, H4, P3 } from '@repo/ui/components/Typography';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 32px;

  ${QUERIES.laptopAndUp} {
    gap: 48px;
  }
`;

export const Title = styled(H2)`
  text-align: center;
  margin-bottom: 48px;

  ${QUERIES.laptopAndUp} {
    margin-bottom: 68px;
  }
`;

export const Item = styled.div`
  display: flex;
  gap: 12px;
  width: 355px;
  max-width: 100%;

  ${QUERIES.laptopAndUp} {
    gap: 24px;
  }
`;

export const Image = styled.img.attrs({ width: 65, height: 65 })`
  border-radius: 5px;
  background-color: transparent;
`;

// H3 on desktop, H4 on mobile
export const ItemTitle = styled(H4)`
  margin-bottom: 8px;
  ${QUERIES.tabletAndUp} {
    margin-bottom: 12px;
    font-size: ${themeStyle.fontSize18};
    line-height: 22px;
  }
`;

// P2 on desktop, P3 on mobile
export const Text = styled(P3)`
  ${QUERIES.tabletAndUp} {
    font-size: ${themeStyle.fontSize16};
    line-height: 22px;
  }

  p {
    min-height: 1em;
    margin: 0px;
  }
`;
